import {
  REQUEST_REPORT_DATA,
  RESPONSE_REPORT_DATA,
  REQUEST_REPORT_DATA_FAILURE,
  SET_REPORT_PARAMS_READY,
  SET_REPORT_PARAMS_NOT_READY,
  SET_REPORT_DATA_NOT_REQUESTED,
  SET_REPORT_DATA_REQUEST,
  CLEAR_REPORT_DATA
} from '../actions/reportDataActions'

import { states } from './queriesStates'

const initialState = {
  dataState: states.NOT_REQUESTED,
  startDate: null,
  endDate: null,
  isReportParamsReady: false,
  isReportDataReady: false
}

const reportDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_REPORT_DATA:
      const { startDate, endDate } = action.payload

      return Object.assign(
        {},
        state,
        {
          dataState: states.REQUEST,
          startDate,
          endDate
        }
      )
    case RESPONSE_REPORT_DATA:
      return Object.assign(
        {},
        state,
        {
          dataState: states.READY,
          isReportDataReady: true
        }
      )
    case REQUEST_REPORT_DATA_FAILURE:
      return Object.assign(
        {},
        state,
        {
          dataState: states.FAILURE,
          isReportDataReady: false
        }
      )
    case SET_REPORT_PARAMS_READY:
      return Object.assign(
        {},
        state,
        {
          isReportParamsReady: true
        }
      )
    case SET_REPORT_PARAMS_NOT_READY:
      return Object.assign(
        {},
        state,
        {
          isReportParamsReady: false
        }
      )
    case SET_REPORT_DATA_NOT_REQUESTED:
      return Object.assign(
        {},
        state,
        {
          dataState: states.NOT_REQUESTED
        }
      )
    case SET_REPORT_DATA_REQUEST:
      return Object.assign(
        {},
        state,
        {
          dataState: states.REQUEST
        }
      )
    case CLEAR_REPORT_DATA:
      return Object.assign(
        {},
        state,
        initialState
      )
    default:
      return state
  }
}

export default reportDataReducer